module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_cancer_down-431051a2eb6c34067af3e8370b9d49b3.png";